<template>
  <div>
    <Panel module="Estoque" title="Case" layout="large" :showFilter="false" :showSearch="false" :showButtons="false">
      <div slot="content-main">
        <br />
        <Loading v-if="loading" type="line" :center="false" />

        <div v-else>
          <div class="case-detail-hero">
            <div class="case-detail-hero-icon">
              <i class="fa-solid fa-briefcase"></i>
            </div>
            <div class="case-detail-hero-info">
              <div class="case-detail-hero-line">
                <span class="case-detail-hero-name">{{ caseModel.name }}</span>
                <span class="case-detail-hero-status"
                  :class="isActive ? 'case-detail-hero-status-active' : 'case-detail-hero-status-inactive'">
                  {{ isActive ? "Ativo" : "Inativo" }}
                </span>
              </div>
              <div class="case-detail-hero-tags">
                <span class="case-detail-hero-tag" v-if="caseModel.barCode">
                  <i class="fa-solid fa-barcode"></i> {{ caseModel.barCode }}
                </span>
                <span class="case-detail-hero-tag" v-if="caseModel.rfid">
                  <i class="fa-solid fa-tower-broadcast"></i> {{ caseModel.rfid }}
                </span>
                <span class="case-detail-hero-tag">
                  <i class="fa-solid fa-boxes-stacked"></i> {{ totalItems }} patrimônio(s)
                </span>
              </div>
              <span class="case-detail-hero-description" v-if="caseModel.description">
                {{ caseModel.description }}
              </span>
            </div>
            <Button _key="btnCaseEdit" type="edit" title="Editar Dados" classIcon="fa-solid fa-pen-to-square"
              size="small" :clicked="openEditModal" />
          </div>

          <CaseItemsPanel :caseId="id" @changed="totalItems = $event" />
        </div>
      </div>
    </Panel>

    <Modal title="Case" :width="800" :height="750" v-show="showModal('caseForm')">
      <CaseForm />
    </Modal>
  </div>
</template>

<script>
import Panel from "@/ui/layout/Panel";
import Button from "@/ui/forms/Button";
import Modal from "@/ui/forms/Modal";
import Loading from "@/ui/shared/Loading.vue";

import CaseForm from "../components/case/CaseForm.vue";
import CaseItemsPanel from "../components/case/CaseItemsPanel.vue";

import Case from "../models/Case";
import CaseService from "../services/case.service";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "CaseCreateUpdateView",
  components: { Panel, Button, Modal, Loading, CaseForm, CaseItemsPanel },
  data() {
    return {
      id: this.$route.params.id,
      loading: true,
      caseModel: new Case(),
      totalItems: 0,
    };
  },
  mounted() {
    this.removeLoading(["panel"]);
    this.getById();
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
    isActive() {
      return this.caseModel.status == 1;
    },
  },
  methods: {
    ...mapMutations("generic", ["addEvent", "openModal", "removeLoading"]),
    async getById() {
      this.loading = true;
      try {
        const response = await CaseService.getById(this.id);
        this.caseModel.update(response.content);
      } finally {
        this.loading = false;
      }
    },
    openEditModal() {
      this.openModal("caseForm");
      this.addEvent({ name: "caseUpdate", data: this.caseModel });
      this.removeLoading(["btnCaseEdit"]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name === "caseUpdated") this.getById();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.case-detail-hero {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px 22px;
  background: var(--bg-base);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  margin-bottom: 18px;
}

.case-detail-hero-icon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background: rgba(87, 118, 150, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-brand);
  font-size: 20px;
  flex-shrink: 0;
}

.case-detail-hero-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.case-detail-hero-line {
  display: flex;
  align-items: center;
  gap: 10px;
}

.case-detail-hero-name {
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
}

.case-detail-hero-status {
  font-size: 11px;
  font-weight: 600;
  border-radius: 999px;
  padding: 2px 10px;
  color: var(--text-inverse);
}

.case-detail-hero-status-active {
  background: var(--color-success);
}

.case-detail-hero-status-inactive {
  background: var(--text-muted);
}

.case-detail-hero-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.case-detail-hero-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-secondary);
  background: var(--bg-elevated);
  border-radius: 999px;
  padding: 3px 12px;
}

.case-detail-hero-description {
  font-size: 13px;
  font-style: italic;
  color: var(--text-muted);
}
</style>
